import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

// Arrays para los filtros activos
let activeBrands = [];
let activeApplications = [];
let activeSegments = [];
export class ModWebSearch extends ModuleComponent {

    ready() {
        super.ready();

        const origin = this.$root.data("origin");

        const brandButton = document.querySelector(this.scope+"__filter-brand");
        const applicationButton = document.querySelector(this.scope+"__filter-application");
        const segmentButton = document.querySelector(this.scope+"__filter-segment");

        const brandContainer = document.getElementById("brand-container");
        const applicationContainer = document.getElementById("application-container");
        const segmentContainer = document.getElementById("segment-container");

        function resetAllContainers() {
            brandContainer.style.display = "none";
            applicationContainer.style.display = "none";
            segmentContainer.style.display = "none";

            brandButton.classList.remove("active");
            applicationButton.classList.remove("active");
            segmentButton.classList.remove("active");
        }

        function toggleActive(button, container) {
            syncActiveClasses();
            if (container.style.display === "flex") {
                resetAllContainers();
            } else {
                resetAllContainers();
                button.classList.add("active");
                container.style.display = "flex";
            }
        }

        brandButton.addEventListener("click", () =>{
            toggleActive(brandButton, brandContainer);
        });

        applicationButton.addEventListener("click", ()=> {
            toggleActive(applicationButton, applicationContainer);
        });

        segmentButton.addEventListener("click", ()=> {
            toggleActive(segmentButton, segmentContainer);
        });

        function addActiveFilter(filterType, filterId) {
            switch (filterType) {
                case "brand":
                    if (!activeBrands.includes(filterId)) {
                        activeBrands.push(filterId);
                    }
                    break;
                case "application":
                    if (!activeApplications.includes(filterId)) {
                        activeApplications.push(filterId);
                    }
                    break;
                case "segment":
                    if (!activeSegments.includes(filterId)) {
                        activeSegments.push(filterId);
                    }
                    break;
            }
            updateFilters();
        }

        function removeActiveFilter(filterType, filterId) {
            switch (filterType) {
                case "brand":
                    activeBrands = activeBrands.filter(id => id !== filterId);
                    break;
                case "application":
                    activeApplications = activeApplications.filter(id => id !== filterId);
                    break;
                case "segment":
                    activeSegments = activeSegments.filter(id => id !== filterId);
                    break;
            }
            updateFilters();

        }

        function updateFilters() {

            const endpointMap = {
                project: '/web/web-project/filter-web-project',
                inspiration: '/web/web-inspiration/filter-web-inspiration'
            };

            const endpoint = endpointMap[origin];
            if (!endpoint) return;

            GvfService.endpoint(endpoint, {
                webBrandIds: activeBrands,
                webApplicationIds: activeApplications,
                webSegmentIds: activeSegments
            }).then((resp) => {

                if (resp.html) {
                    const contentDivId = origin === 'project' ? 'projects' : 'inspiration';
                    const contentDiv = document.getElementById(contentDivId);
                    contentDiv.innerHTML = resp.html;
                    GvfUiService.init($(resp.html));
                    activeBrands = resp.brandIds;
                    activeApplications = resp.applicationIds;
                    activeSegments = resp.segmentIds;
                }
            });

        }

        function handleRemoveActiveFilter(event) {
            const element = event.target;
            const brandId = element.getAttribute('data-brand');
            const applicationId = element.getAttribute('data-application');
            const segmentId = element.getAttribute('data-segment');

            if (brandId) {
                const brandItem = document.querySelector(`[data-brand="${brandId}"]`);
                if (brandItem) brandItem.classList.remove("active");
                removeActiveFilter("brand", brandId);
            } else if (applicationId) {
                const applicationItem = document.querySelector(`[data-application="${applicationId}"]`);
                if (applicationItem) applicationItem.classList.remove("active");
                removeActiveFilter("application", applicationId);
            } else if (segmentId) {
                const segmentItem = document.querySelector(`[data-segment="${segmentId}"]`);
                if (segmentItem) segmentItem.classList.remove("active");
                removeActiveFilter("segment", segmentId);
            }
        }


        const inactiveFilterButtons = document.querySelectorAll(this.scope + "__inactive-filter");
        inactiveFilterButtons.forEach(button => {
            button.addEventListener("click", handleRemoveActiveFilter);
        });

        const brandItems = document.querySelectorAll(this.scope+"__filter-brands");
        brandItems.forEach(item => {
            item.addEventListener("click", ()=> {
                const filterId = item.getAttribute('data-brand');
                addActiveFilter("brand", filterId);
            });
        });

        const applicationItems = document.querySelectorAll(this.scope+"__filter-applications");
        applicationItems.forEach(item => {
            item.addEventListener("click",  () =>{
                const filterId = item.getAttribute('data-application');
                addActiveFilter("application", filterId);
            });
        });

        const segmentItems = document.querySelectorAll(this.scope+"__filter-segments");
        segmentItems.forEach(item => {
            item.addEventListener("click", () =>{
                const filterId = item.getAttribute('data-segment');
                addActiveFilter("segment", filterId);
            });
        });

        function syncActiveClasses() {
            brandItems.forEach(item => {
                const filterId = item.getAttribute('data-brand');
                if (activeBrands.includes(filterId)) {
                    item.classList.add("active");
                }
            });

            applicationItems.forEach(item => {
                const filterId = item.getAttribute('data-application');
                if (activeApplications.includes(filterId)) {
                    item.classList.add("active");
                }
            });

            segmentItems.forEach(item => {
                const filterId = item.getAttribute('data-segment');
                if (activeSegments.includes(filterId)) {
                    item.classList.add("active");
                }
            });
        }
    }

}